var map = {
	"./google-play-badge_en.png": [
		95252,
		252
	],
	"./google-play-badge_jp.png": [
		49455,
		455
	],
	"./google-play-badge_pt.png": [
		55525,
		525
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 21970;
module.exports = webpackAsyncContext;